import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { makePrioStyles } from '../../../theme/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@prio365/prio365-react-library';
import { DashboardItem } from '../../../models/Dashboard';

const useStyles = makePrioStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.application.background.light,
    color: theme.colors.application.typography.default,
    width: '100%',
    padding: ` ${theme.spacing.large}px ${theme.spacing.regular}px`,
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing.small,
    borderRadius: theme.borderRadius.regular,
    '& h4': {
      color: theme.colors.application.typography.default,
    },
  },
}));

interface WidgetCardProps {
  className?: string;
  item: DashboardItem;
  onAdd?: (item: DashboardItem) => void;
}

export const WidgetCard: React.FC<WidgetCardProps> = (props) => {
  //#region ------------------------------ Defaults
  const { className, item, onAdd } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const icon = (() => {
    switch (item.type) {
      case 'absenceOverview':
        return 'calendar-alt';
      case 'absenceNotifications':
        return 'bell';
      case 'upcomingAbsences':
        return 'calendar-check';
      case 'inboxOverview':
        return 'envelope';
      case 'projectInfos':
        return 'project-diagram';
      case 'upcomingBirthdays':
        return 'birthday-cake';
      case 'reteachOverview':
        return 'school';
      case 'pendingActions':
        return 'tasks';
      case 'hrTimekeepingOverview':
        return 'clock';
      case 'overtimeOverview':
        return 'business-time';
      case 'projectNews':
        return 'newspaper';
      case 'links':
        return 'link';
      case 'powerBI':
        return 'chart-simple';
      default:
        return 'question-circle';
    }
  })();
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <div className={classNames(classes.root, className)}>
      <FontAwesomeIcon
        icon={['fal', icon]}
        style={{ fontSize: '24px' }}
      ></FontAwesomeIcon>
      <h4 style={{ textAlign: 'center' }}>
        {t(`dashboard:widgets.title.${item.type}`)}
      </h4>
      <p style={{ textAlign: 'center' }}>
        {t(`dashboard:widgets.description.${item.type}`)}
      </p>
      <Button style={{ width: '100%' }} onClick={() => onAdd?.(item)}>
        {t('dashboard:widgets.addWidgetDrawer.addButton')}
      </Button>
    </div>
  );
};

export default WidgetCard;
